import api from '../api';
import { FaqItem, ApiError } from './types';

export class FaqService {
  /**
   * Lista todas as perguntas frequentes
   * @returns Promise com array de FAQs
   */
  static async getFaqs(): Promise<FaqItem[]> {
    try {
      // Endpoint público - não requer autenticação
      const response = await api.get<FaqItem[]>('faq');
      return response.data;
    } catch (error: any) {
      throw this.handleApiError(error);
    }
  }

  /**
   * Trata erros da API
   */
  private static handleApiError(error: any): ApiError {
    if (error.response?.data) {
      return {
        message: error.response.data.message || 'Erro na requisição',
        statusCode: error.response.status,
        error: error.response.data.error,
      };
    }

    return {
      message: 'Erro de conexão com o servidor',
      statusCode: 500,
      error: 'Network Error',
    };
  }
}
